export default "__VITE_ASSET__C82N1mvU__"